import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Code, XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '../AuthContext';

const PaymentCancel = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  React.useEffect(() => {
    if (!user) {
      navigate('/login');
    }
  }, [user, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-red-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-2xl shadow-2xl p-12 text-center">
          <div className="flex items-center justify-center mb-6">
            <Code className="w-8 h-8 text-violet-600" />
            <span className="text-2xl font-bold text-slate-900 ml-2">CodeITT</span>
          </div>

          <XCircle className="w-20 h-20 text-red-500 mx-auto mb-6" />
          <h1 className="text-4xl font-bold text-slate-900 mb-4">Payment Cancelled</h1>
          <p className="text-lg text-slate-600 mb-8">
            Your payment was cancelled. No charges have been made to your account.
          </p>

          <div className="bg-slate-50 rounded-xl p-6 mb-8">
            <p className="text-slate-700">
              If you experienced any issues during checkout or have questions about our pricing plans, please don't hesitate to contact our support team.
            </p>
          </div>

          <div className="space-y-3">
            <Button
              onClick={() => navigate('/payment')}
              className="w-full bg-violet-600 hover:bg-violet-700 text-white h-12 rounded-full font-medium"
              data-testid="try-again-btn"
            >
              Try Again
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate('/student/dashboard')}
              className="w-full h-12 rounded-full font-medium"
              data-testid="back-to-dashboard-btn"
            >
              Back to Dashboard
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
